module.exports = __webpack_public_path__ + "static/media/black_van_road.00baefca.jpg";